export default function () {
    const navigationElement = document.getElementById('header');
    const quickNavElement = document.getElementById('navigation-anchor-menu');
    const header = document.querySelectorAll("#navigation-two")[0];
    const menu = document.getElementById('menu');

    if (quickNavElement !== null) {
        // Horizontal scroll inside quickNavElement
        document.addEventListener('DOMContentLoaded', function () {
            quickNavElement.style.cursor = 'grab';

            let pos = {top: 0, left: 0, x: 0, y: 0};

            const mouseDownHandler = function (e) {
                quickNavElement.style.cursor = 'grabbing';
                quickNavElement.style.userSelect = 'none';

                pos = {
                    left: quickNavElement.scrollLeft,
                    top: quickNavElement.scrollTop,
                    // Get the current mouse position
                    x: e.clientX,
                    y: e.clientY,
                };

                document.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);
            };

            const mouseMoveHandler = function (e) {
                // How far the mouse has been moved
                const dx = e.clientX - pos.x;
                const dy = e.clientY - pos.y;

                // Scroll the element
                quickNavElement.scrollTop = pos.top - dy;
                quickNavElement.scrollLeft = pos.left - dx;
            };

            const mouseUpHandler = function () {
                quickNavElement.style.cursor = 'grab';
                quickNavElement.style.removeProperty('user-select');

                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);
            };

            // Attach the handler
            quickNavElement.addEventListener('mousedown', mouseDownHandler);
        });

        // Scroll Manager.
        const quickNavElementTopPos = quickNavElement.getBoundingClientRect().top;
        let scrollDirection = 'down';
        let scrollPosition = 0;

        window.addEventListener('scroll', function () {
            if (window.scrollY < scrollPosition) {
                scrollDirection = 'up';
            } else {
                scrollDirection = 'down';
            }

            if (scrollDirection === 'down') {
                if (window.scrollY > quickNavElementTopPos) {
                    header.classList.add("going-up");
                    if(!menu.classList.contains("is-active")) {
                        navigationElement.classList.add('remove-main-nav');
                    }
                } else {
                    header.classList.remove("going-up");
                    navigationElement.classList.remove('remove-main-nav');
                }
            } else {
                header.classList.remove("going-up");
                navigationElement.classList.remove('remove-main-nav');
            }

            scrollPosition = window.scrollY;
        });

        let currentTop = 0;
        let anchor = document.querySelectorAll('.anchor');
        document.querySelectorAll('.navigation-anchor-item').forEach(t => {
            t.addEventListener('click', () => {
                let el = document.querySelector(t.getElementsByTagName('a')[0].getAttribute('href'));
                let newTop = el.offsetTop;

                if (newTop < currentTop) {
                    anchor.forEach(a => {
                        a.classList.add("going-up");
                    });
                } else {
                    anchor.forEach(a => {
                        a.classList.remove("going-up");
                    });
                }

                setTimeout(() => {
                    currentTop = newTop;
                }, 1000);
            })
        });

        if (document.getElementsByClassName('page-template-template-reviews').length > 0) {
            let stickyPos = header.offsetTop - 96;

            window.onscroll = function () {
                myFunction(stickyPos, header)
            };
        }
    }


    function myFunction(stickyPos, header) {
        if (window.scrollY > stickyPos) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }
}
